import { c as _c } from "react/compiler-runtime";
import { Badge, HStack, Heading, Tag, Text, VStack } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { AiOutlineStock } from 'react-icons/ai';
interface BrandCardProps {
  companyName?: string;
  amountRaised?: string;
  bgImageUrl?: string;
  badgeLabel?: string;
  bgColor?: string;
  bgGradient?: string;
  showIPO?: boolean;
  alternate?: boolean;
  id?: string;
}
const BrandCard: React.FC<BrandCardProps> = t0 => {
  const $ = _c(32);
  const {
    companyName,
    amountRaised,
    bgImageUrl,
    badgeLabel,
    showIPO,
    id
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t1 = `linear-gradient(180deg, transparent, {colors.colorPalette.muted} 80%), url(${bgImageUrl}) center center/cover no-repeat`;
  let t2;
  if ($[0] !== getBreakpointValue) {
    t2 = getBreakpointValue({
      base: 5,
      md: 20
    });
    $[0] = getBreakpointValue;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== getBreakpointValue) {
    t3 = getBreakpointValue({
      base: 6,
      md: 6
    });
    $[2] = getBreakpointValue;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== badgeLabel) {
    t4 = <Badge size="md" variant="solid">{badgeLabel}</Badge>;
    $[4] = badgeLabel;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== getBreakpointValue) {
    t5 = getBreakpointValue({
      base: 4,
      md: 6
    });
    $[6] = getBreakpointValue;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== companyName) {
    t6 = <Heading color="colorPalette.fg" fontSize="2xl" fontWeight="medium">{companyName}</Heading>;
    $[8] = companyName;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Text color="colorPalette.fg" textStyle="label">Total Raised</Text>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== getBreakpointValue) {
    t8 = getBreakpointValue({
      base: "xl",
      md: "3xl"
    });
    $[11] = getBreakpointValue;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== amountRaised || $[14] !== t8) {
    t9 = <Text color="colorPalette.fg" fontSize={t8} fontWeight="medium">${amountRaised}</Text>;
    $[13] = amountRaised;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== showIPO) {
    t10 = showIPO && <Tag.Root bgColor="colorPalette.container" fontSize="xs" fontWeight={700} gap={1} rounded="full"><AiOutlineStock />IPO</Tag.Root>;
    $[16] = showIPO;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <VStack align="flex-start" gap={0}>{t7}<HStack gap={3}>{t9}{t10}</HStack></VStack>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t5 || $[23] !== t6) {
    t12 = <VStack align="flex-start" gap={t5}>{t6}{t11}</VStack>;
    $[21] = t11;
    $[22] = t5;
    $[23] = t6;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== id || $[26] !== t1 || $[27] !== t12 || $[28] !== t2 || $[29] !== t3 || $[30] !== t4) {
    t13 = <VStack align="flex-start" background={t1} borderRadius="2xl" boxShadow="sm" gap={t2} height="full" id={id} justify="space-between" padding={t3} width="full">{t4}{t12}</VStack>;
    $[25] = id;
    $[26] = t1;
    $[27] = t12;
    $[28] = t2;
    $[29] = t3;
    $[30] = t4;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};
export default BrandCard;